import request from '../utils/request'

export function setCustomerTagApi (data) {
  return request({
    url: 'api/customer/setCustomerTag',
    method: 'post',
    data
  })
}

export function eventDeliveryProtoListPageApi (data) {
  return request({
    url: 'api/eventDelivery/protoListPage',
    method: 'post',
    data
  })
}

export function eventDeliveryBatchDeliveryProtoApi (data) {
  return request({
    url: 'api/eventDelivery/batchDeliveryProto',
    method: 'post',
    data
  })
}

export function customerAppDataListPageApi (data) {
  return request({
    url: 'api/customer/appDataListPage',
    method: 'post',
    data
  })
}

export function visitPlanTargetIdListApi (params) {
  return request({
    url: 'api/visitPlan/planTargetIdList',
    method: 'get',
    params
  })
}

export function visitPlanAddDetailApi (data) {
  return request({
    url: 'api/visitPlan/addDetail',
    method: 'post',
    data
  })
}
export function changeListPageApi (data) {
  return request({
    url: 'api/change/listPage',
    method: 'post',
    data
  })
}

export function customerShelfGeneralApi (customerId) {
  return request({
    url: `api/customerShelf/general/${customerId}`,
    method: 'get'
  })
}

export function customerShelfInfoApi (customerId) {
  return request({
    url: `api/customerShelf/shelfInfo/${customerId}`,
    method: 'get'
  })
}

export function sdShelfGeneralApi (customerId) {
  return request({
    url: `api/sdShelf/general/${customerId}`,
    method: 'get'
  })
}

export function sdShelfShelfInfoApi (customerId) {
  return request({
    url: `api/sdShelf/shelfInfo/${customerId}`,
    method: 'get'
  })
}

export function homeCurrentTimeApi () {
  return request({
    url: 'api/home/currentTime',
    method: 'get'
  })
}
